<script lang="jsx">
import { caseOf, map } from '../../lib'
import { mapGetters, mapActions } from 'vuex'
import Retry from '../../components/Retry'
import UserPermissionsTableVue from '../../components/UserPermissionsTable.vue'
import SetPermissionsForm from '../../components/SetPermissionsForm.vue'
import RegisterLink from '../../components/RegisterLink.vue'
import { config } from '@/lib/helpers/config.helpers'
const SpinnerView = () => (
  <div class="spinner-container">
    <div class="spinner" />
  </div>
)

export default {
  data() {
    return { id: this.$route.params.id }
  },
  computed: {
    ...mapGetters('stores', [
      'usersStore',
      'storeUsers',
      'usersStatus',
      'registerLinks',
      'registerLinksStatus',
      'usersList',
      'registerLink',
      'userEmail',
      'storePermissionError',
      'storePermissionSuccess',
      'permissions',
      'permissionsList',
      'loading',
    ]),
  },
  created() {
    this.init({ id: this.id })
  },
  methods: {
    ...mapActions('stores', [
      'init',
      'update',
      'createPermissions',
      'updateUsersList',
      'findUsers',
      'createRegisterLink',
      'deletePermissions',
    ]),
    autoCompleteUpdate(value) {
      this.updateUsersList({ path: 'value', value })
      this.findUsers(value)
    },
    getRegisterUrl(code) {
      return `${config.identityAppUrl}/auth/registration?app=advertiser&invitation_code=${code}`
    },
  },
  render() {
    return (
      <div class="page">
        {this.storePermissionError ? <div class="error">{this.storePermissionError}</div> : ''}
        {this.storePermissionSuccess ? <div class="success">{this.storePermissionSuccess}</div> : ''}
        <h2>Users permissions in Store {this.usersStore.feed_name}</h2>
        <div class="card">
          {this.loading ? (
            <SpinnerView />
          ) : (
            <UserPermissionsTableVue
              users={this.storeUsers}
              id={this.id}
              updateUserPermission={this.update}
              onSave={this.createPermissions}
              onDelete={this.deletePermissions}
              permissionsList={this.permissionsList}
            />
          )}
        </div>

        <div>
          <h2>Set Permissions</h2>
          <SetPermissionsForm
            autoCompleteUpdate={this.autoCompleteUpdate}
            autoCompleteSuggestions={this.usersList.suggestions}
            updateSelectedUser={this.updateUsersList}
            value={this.usersList.value}
            id={this.id}
            userEmail={this.userEmail}
            selectedUser={this.usersList.selected}
            registerLink={this.registerLink}
            updatePermission={this.update}
            createPermissions={this.createPermissions}
            createRegisterLink={this.createRegisterLink}
            checkablePermissions={this.permissions}
            permissionsList={this.permissionsList}
          />
        </div>

        <div>
          <h2>Register Links</h2>
          {caseOf(this.registerLinksStatus, {
            Idle: () => null,
            Processing: () => <SpinnerView />,
            Done: () => (
              <div>
                {this.registerLinks.length ? (
                  map(this.registerLinks, (permission) => {
                    let hide = permission.config.hide
                    Array.isArray(hide) ? (hide = hide.join(', ')) : (hide = null)
                    return <RegisterLink url={this.getRegisterUrl(permission.code)} email={permission.email} hide={hide} />
                  })
                ) : (
                  <div class="info">There are no register links for this store</div>
                )}
              </div>
            ),
            Failed: () => <Retry refresh={() => this.fetchRegisterLinks(this.id)} />,
          })}
        </div>
      </div>
    )
  },
}
</script>
